import { Component, OnInit, OnDestroy } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { GiftCardOrderSalesModel, GiftCardVirtualsModel } from "src/app/models/gifcardVirtual.model";
import { saveAs } from 'file-saver';
import { ExcelService } from 'src/app/services/excel.service';
import { AuthService } from 'src/app/services/auth.service';
import { timer } from 'rxjs';
import { Subscription } from 'rxjs';
import { TraceService } from 'src/app/services/trace.service';
import { ParameterService } from 'src/app/services/parameter.service';
import { ParameterModel } from 'src/app/models/parameter.model';

@Component({
  selector: 'app-ordersales-step2-list',
  templateUrl: './ordersales-step2-list.component.html',
  styleUrls: ['./ordersales-step2-list.component.css']
})
export class OrderSalesStep2ListComponent implements OnInit, OnDestroy {

  constructor(private giftCardService: GifcardVirtualService,
    private messageService: MessageService,
    private excelService: ExcelService,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    private traceService: TraceService,
    private parameterService: ParameterService) { }

  private subscription: Subscription = new Subscription();
  totalOrderSales: number;
  dlgOrderSales: boolean;
  dlgEmailFails: boolean;
  dlgUpdateEmail: boolean;
  itemOrderSales;
  itemSendFails;
  selectOrderSales: GiftCardOrderSalesModel;
  datasourceTablaOrderSales: GiftCardOrderSalesModel[] = [];
  colsTablaOrderSales: any[];
  colsTablaEmailFails: any[];
  dataDetail: {};
  datasourceGiftCardVirtual: GiftCardVirtualsModel[] = [];
  loading: boolean = false;
  currentUser: string;
  observation: string;
  dlgReject: boolean = false;
  permLow: number = 0;
  permMedium: number = 0;
  permHigh: number = 0;
  datasourceParameters: ParameterModel[] = [];

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
    this.createColumnsTablaGiftCardVirtual();
    this.populateListParameters();
    //this.refreshData();
    this.populateTableOrderSales();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  refreshData() {
    this.subscription.add(this.populateTableOrderSales());
    this.subscription.add(this.subscribeToData());
  }

  subscribeToData() {
    this.subscription.add(console.log("refreshdata"));
    this.subscription.add(
      timer(60000).subscribe(() => this.refreshData())
    );
  }

  createColumnsTablaGiftCardVirtual() {
    this.colsTablaOrderSales = [
      { field: 'NRO_ORDEN_COMPRA', header: 'Nro. Ord. Compra', width: '8%', align: 'center' },
      { field: 'DESC_MODELO_GIFT_CARD', header: 'Modelo Giftcard', width: '10%', align: 'center' },
      { field: 'NRORUC_CLIENTE', header: 'RUC', width: '7%', align: 'center' },
      { field: 'RAZSOC_CLIENTE', header: 'Razón Social', width: '25%', align: 'center' },      
      { field: 'IMP_ORDEN_COMPRA', header: 'Importe', width: '8%', align: 'center' },
      { field: 'CAN_ORDEN_COMPRA', header: 'Cant.', width: '6%', align: 'center' },
      { field: 'CREATIONUSER', header: 'Usuario Registro', width: '6%', align: 'center' },
      { field: 'CREATIONDATE', header: 'Fecha Registro', width: '6%', align: 'center' },
      { field: 'PERMANENCIA', header: 'Días Perman.', width: '6%', align: 'center' }
    ];
  }

  populateTableOrderSales() {
    this.loading = true;
    let params = {
      "p_flag_activo": 6,
      "p_isfacturado":"N"
    }

    this.giftCardService.GetOrderSalesByStatus(params).subscribe(
      (response: GiftCardOrderSalesModel[]) => {
        this.datasourceTablaOrderSales = response;
        this.totalOrderSales = this.datasourceTablaOrderSales.length;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar las ordenes de compra.' });
      }
    )
  }
  
  populateListParameters() {
    this.parameterService.GetGiftCardParameters().subscribe(
      (response: ParameterModel[]) => {
        this.datasourceParameters = response;
        if (this.datasourceParameters) {
          this.datasourceParameters.forEach(param => {
            if (param.KEY_PARAMETER == 'GCV_PERM_LOW')
              this.permLow = Number(param.VALUE_SHORT);
            else if (param.KEY_PARAMETER == 'GCV_PERM_MEDIUM')
              this.permMedium = Number(param.VALUE_SHORT);
            else if (param.KEY_PARAMETER == 'GCV_PERM_HIGH')
              this.permHigh = Number(param.VALUE_SHORT);
          });
        }
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar parámetros.' });
      }
    )
  }

  populateTablaGiftCardVirtual() {
    this.loading = true;
    let order = {
      "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
      "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
      "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
      "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT
    };
    this.giftCardService.GetGiftCardVirtuals(order).subscribe(
      (response: GiftCardVirtualsModel[]) => {
        this.datasourceGiftCardVirtual = response;
        this.excelService.exportAsExcelFile(this.datasourceGiftCardVirtual, 'giftcard');
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar gift card.' });
      }
    )
  }

  onShowConfirmApprove() {
    this.confirmationService.confirm({
      message: '¿Está seguro de aprobar la orden de compra?',
      accept: () => {
        this.loading = true;
        this.updateOrderSalesStatus(7);
        this.createOrderSalesTrace('APROBADO');
      }
    });
  }

  onShowConfirmReject() {
    if (this.observation) {
      this.confirmationService.confirm({
        message: '¿Está seguro de rechazar la orden de compra?',
        accept: () => {
          this.loading = true;
          this.updateOrderSalesStatus(-6);
          this.createOrderSalesTrace('RECHAZADO');
        }
      });
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe ingresar el motivo del rechazo en el campo observación' });
    }
  }

  createOrderSalesTrace(status: string) {
    let params = {
      "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
      "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
      "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
      "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
      "p_type_order_sales" : 'V',
      "p_action": status,
      "p_observation": this.observation ? this.observation : 'Aprobado Correctamente.',
      "p_creationuser": this.currentUser
    };
    this.traceService.CreateGiftCardOrderSalesTrace(params).subscribe(
      (response) => {
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Trace registrado correctamente.' });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear el trace de la orden de compra' });
      }
    )
  }

  updateOrderSalesStatus(flg_activo: number) {
    let params = {
      "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
      "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
      "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
      "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
      "p_flg_activo": flg_activo
    }
    this.giftCardService.UpdateOrderSalesStatus(params).subscribe(
      (response) => {
        this.dlgOrderSales = false;
        this.dlgReject = false;
        this.populateTableOrderSales();
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Actualización del estado de la orden de compra: exitoso.' });
      },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar el estado de la orden de compra.' });
      }
    )
  }

  onShowDlgReject() {
    this.dlgReject = true;
  }

  onShowDlgOrderSales(order: GiftCardOrderSalesModel) {
    this.itemOrderSales = order;
    this.dlgOrderSales = true;
  }

  downloadIMGModel() {
    saveAs(this.itemOrderSales.IMG_MODELO_GIFT_CARD, "modelo.jpg");
  }

  downloadIMGOrder() {
    saveAs(this.itemOrderSales.IMG_ORDEN_COMPRA, "orden.jpg");
  }

  downloadIMGCotizacion() {
    saveAs(this.itemOrderSales.IMG_COTIZACION, "cotizacion.jpg");
  }

  donwloadAdicional1() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL1, "adicional.jpg");
  }

  donwloadAdicional2() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL2, "adiciona2.jpg");
  }

  donwloadAdicional3() {
    saveAs(this.itemOrderSales.IMG_ADICIONAL3, "adiciona3.jpg");
  }
}